import type { GQL_ID } from '@@partner:types:graphql'
import type { SlotPlanInfo } from '@@partner:types:app'

import React from 'react'

import {
  representTimeWithDateObject,
  convertDateObjectToSeconds
} from '@@partner:helpers/date-utils'

import { Button, Table, InputNumber } from 'rsuite'
import LegacyTrashIcon from '@rsuite/icons/legacy/Trash'
import TimePicker from '@components/common/TimePicker'

export interface Slots {
  from: string
  to: string
  maxorders: string
  maxpositions: string
}

export interface SlotsTableProps {
  slots: SlotPlanInfo[]
  onDelete: (slot: SlotPlanInfo) => void
  onChange: (slot: Partial<SlotPlanInfo>) => void
}

const { Column, HeaderCell, Cell } = Table

export default function SlotTable ({
  slots = [],
  onDelete,
  onChange
}: SlotsTableProps) {
  const makeChangeHandler =
    (id: GQL_ID | undefined, field: string) => (value) => {
      if (id) {
        onChange({ id, [field]: value })
      }
    }

  const makeTimeChangeHandler =
    (id: GQL_ID | undefined, field: string) => (value) => {
      if (id) {
        onChange({ id, [field]: value })
      }
    }

  return (
    <Table
      data={slots}
      autoHeight
      bordered
      cellBordered
      wordWrap
      className="ShopForm__Slots__Table"
      rowHeight={60}
    >
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>С</HeaderCell>
        <Cell dataKey="slotStartTime">
          {(row: SlotPlanInfo) => (
            <TimePicker
              value={representTimeWithDateObject(row.slotStartTime)}
              disabled={!row.id}
              onSelect={makeTimeChangeHandler(row.id, 'slotStartTime')}
            />
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>ПО</HeaderCell>
        <Cell dataKey="slotFinishTime">
          {(row: SlotPlanInfo) => (
            <TimePicker
              value={representTimeWithDateObject(row.slotFinishTime)}
              disabled={!row.id}
              onSelect={makeTimeChangeHandler(row.id, 'slotFinishTime')}
            />
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>Максимум заказов</HeaderCell>
        <Cell dataKey="ordersLimit">
          {(row: SlotPlanInfo) => (
            <InputNumber
              value={row.ordersLimit}
              min={0}
              step={1}
              disabled={!row.id}
              onChange={makeChangeHandler(row.id, 'ordersLimit')}
            />
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>Максимум позиций</HeaderCell>
        <Cell dataKey="positionsLimit">
          {(row: SlotPlanInfo) => (
            <InputNumber
              value={row.positionsLimit}
              min={0}
              step={1}
              disabled={!row.id}
              onChange={makeChangeHandler(row.id, 'positionsLimit')}
            />
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>Таймаут слота (в минутах)</HeaderCell>
        <Cell dataKey="slotTimeout">
          {(row: SlotPlanInfo) => (
            <InputNumber
              value={row.slotTimeout}
              min={0}
              step={1}
              disabled={!row.id}
              onChange={makeChangeHandler(row.id, 'slotTimeout')}
            />
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(row: SlotPlanInfo) => (
            <Button color="red" onClick={() => onDelete(row)}>
              <LegacyTrashIcon />
            </Button>
          )}
        </Cell>
      </Column>
    </Table>
  )
}
